import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X3LevelStore} from '../X3LevelStore';

@observer
export class DeleteUnitControls extends React.Component<{ store: X3LevelStore }> {
  render() {
    const {store} = this.props;

    if (store.deleteUnit === null)
      return null;

    const deleteUnit = store.deleteUnit;
    const isFailure = deleteUnit.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting unit" state={deleteUnit.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDelete(deleteUnit.unitId)}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
